/** Hand the browser a text file to save (the legacy app's file-saver
 * moves, without the dependency). */
export function downloadTextFile(filename: string, text: string, type: string) {
    const a = document.createElement('a');
    const url = URL.createObjectURL(new Blob([text], { type }));
    a.href = url;
    a.download = filename;
    document.body.append(a);
    a.click();
    a.remove();
    // Deferred: revoking synchronously can abort a download the browser
    // hasn't finished starting (Firefox/Safari queue it asynchronously).
    setTimeout(() => URL.revokeObjectURL(url), 1_000);
}
